import { render, staticRenderFns } from "./CreateNomenclatureService.vue?vue&type=template&id=ed945976&scoped=true"
import script from "./CreateNomenclatureService.vue?vue&type=script&lang=js"
export * from "./CreateNomenclatureService.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclatureService.vue?vue&type=style&index=0&id=ed945976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed945976",
  null
  
)

export default component.exports